module.exports = __webpack_public_path__ + "static/media/outlet-offpacksmart.15948894.mp4";